import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth.js";
import notification from "./notification.js";
import unit from "./unit.js";
import customer from "./customer.js";
import problem from "./problem.js";
import payment from "./payment.js";
import service from "./service.js";
import item from "./item.js";
import invoice from "./invoice.js";
import supplier from "./supplier.js";
import summary from "./summary.js";
import reminder from "./reminder.js";
import employee from "./employee.js";
import importBatch from "./importBatch.js";
import wage from "./wage.js";
import branch from "./branch.js";
import chart_of_account from "./chart_of_account.js";
import journal_entry from "./journal_entry.js";
import quotation from "./quotation.js";
import item_type from "./item_type.js";
import item_sub_type from "./item_sub_type.js";
import item_transfer from "./itemTransfer.js";
import benefit from "./benefit.js";
import position from "./position.js";
import employee_benefit from "./employee_benefit.js";
import cash_advance from "./cash_advance.js";
import featured_content from "./modules/featured_content.js";
import customer_purchase_order from "./modules/customer_purchase_order.js";
import internal_purchase_order from "./modules/internal_purchase_order.js";
import purchase_order from "./modules/purchase_order.js";
import navbar from "./modules/navbar.js";
import theme from "./modules/theme.js";
import bundle_template from "./bundle_template.js";
import task_template from "./modules/task_template.js";
import stock_alert from "./modules/stock_alert.js";
import http_status from "./modules/http_status.js";
import inventory_reports from "./modules/inventory_reports.js";
import service_reports from "./modules/service_reports.js";
import warranty_policy from "./modules/warranty_policy.js";
import facilities from "./modules/facilities.js";
import deposit_record from "./modules/deposit_record.js";
import bank_template from "./modules/bank_template.js";
import permission from "./modules/permission.js";
import printable_forms from "./modules/printable_forms.js";
import sms from "./modules/sms.js";
import field_job_order from "./field_job_order.js";
import quotation_summary from "./quotation_summary.js";
import vp_operations_dashboard from "./modules/vp_operations_dashboard.js";
import customer_retention_dashboard from "./modules/customer_retention_dashboard.js";
import lead from "./lead.js";
import sales from "./sales.js";
import ar from "./ar.js";
import recurring_invoice from "./recurring_invoice.js";
import installed_system from "./installed_system.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    item_type,
    item_sub_type,
    supplier,
    summary,
    auth,
    notification,
    unit,
    customer,
    problem,
    payment,
    service,
    item,
    invoice,
    reminder,
    employee,
    importBatch,
    wage,
    chart_of_account,
    journal_entry,
    branch,
    quotation,
    item_transfer,
    benefit,
    position,
    employee_benefit,
    cash_advance,
    featured_content,
    customer_purchase_order,
    internal_purchase_order,
    purchase_order,
    navbar,
    theme,
    bundle_template,
    task_template,
    stock_alert,
    http_status,
    inventory_reports,
    service_reports,
    warranty_policy,
    facilities,
    deposit_record,
    bank_template,
    permission,
    printable_forms,
    sms,
    field_job_order,
    quotation_summary,
    vp_operations_dashboard,
    customer_retention_dashboard,
    lead,
    sales,
    ar,
    recurring_invoice,
    installed_system,
  },
});
